// extracted by mini-css-extract-plugin
export var subtitle = "_8f-2";
export var title = "_8f-0";
export var titleNoWrap = "_8f-1";